'use strict';
var quickViewBase = require('brand_core/product/quickView');
var detail = require('./detail');
var base = require('./base');
var quickShopDataLayer = require('./quickShopDataLayer');

quickViewBase.setColorAttribute = base.setColorAttribute;

// Overridden to omit contentsquare_color_value: this brand's addToCart productAdd event (see ./base.js)
// does not include contentsquare_color_value, so quickShopAddToBag must not include it either (PMG-1780)
quickViewBase.trackAddToCart = function () {
    $('body').on('product:afterAddToCartGtm', function (e, data) {
        if ($('.quick-modal.show').length === 0) {
            return;
        }
        var gtmProductDetails = data.gtmProductDetails;
        var atcData = {
            color: gtmProductDetails.color || '',
            color_value: gtmProductDetails.color_value || '',
            quantity: data.quantity,
            size: gtmProductDetails.size || '',
            collegiate: gtmProductDetails.isEmbroidered,
            dmpk: gtmProductDetails.length || gtmProductDetails.inseam || gtmProductDetails.hand || gtmProductDetails.width || '',
            style_number: gtmProductDetails.manufacturerSKU,
            master_upc: gtmProductDetails.masterProductId,
            upc: gtmProductDetails.variantID || ''
        };
        var qsContext = { qsOriginUrl: window.location.href, qsSheetType: 'singleProduct' };
        var stlContext = quickShopDataLayer.getShopTheLookContext();
        quickShopDataLayer.pushQuickShopAddToBagEvent(qsContext, stlContext, atcData);
    });
};

quickViewBase.bisnFeature = function () {
    $('body').on('quickview:change', function () {
        if ($('.quick-modal button.bis-notify-me').length) {
            base.methods.loadBisn($('.quick-modal'));
        }
    });
};

quickViewBase.customEmbroidery = function () {
    $('body').on('shown.bs.modal', '.modal.quick-modal', function () {
        var customEmbroideryModal = require('./customEmbroideryModal');
        customEmbroideryModal.init();
    });

    // $('body').on('hide.bs.modal', '.modal.quick-modal', function (e) {
    //     if ($('.embroidery-overlay.is-open').length) {
    //         e.preventDefault(); // Prevent Quick View from closing if embroidery overlay is open
    //     }
    // });
};

if ($('.container.product-detail').length === 0 && $('.embroidery-landing-container').length === 0) {
    quickViewBase.addToCart = base.addToCart;
    quickViewBase.updateAddToCart = detail.updateAddToCart;
    quickViewBase.updateCount = base.updateCount;
}

module.exports = quickViewBase;
